import axiosInstance from "./BaseService";
import StateData from "../models/StateData";
import LanguageData from "../models/LanguageData";

// Function to fetch all states
const fetchStates = async () => {
    try {
        const response = await axiosInstance.get<StateData[]>("/states");
        return response.data;
    } catch (error) {
        throw error;
    }
}

// Function to fetch state by state code
const fetchStateByCode = async (stateCode: string) => {
    try {
        const response = await axiosInstance.get<StateData>(`/states/code/${stateCode}`);
        return response.data;
    } catch (error) {
        throw error;
    }
}

// Cache for state names to avoid repeated API calls
const stateNameCache: { [key: string]: string } = {};
const loadingStates: { [key: string]: Promise<string> } = {};

// Function to get state name by code with caching
const getStateNameByCode = async (stateCode: string): Promise<string> => {
    if (stateNameCache[stateCode]) {
        return stateNameCache[stateCode];
    }
    
    // Create and cache the loading promise
    loadingStates[stateCode] = (async () => {
        try {
            const state = await fetchStateByCode(stateCode);
            stateNameCache[stateCode] = state.name;
            delete loadingStates[stateCode]; // Clean up loading state
            return state.name;
        } catch (error) {
            delete loadingStates[stateCode]; // Clean up loading state
            return stateCode; // Return code if name not found
        }
    })();
    
    return loadingStates[stateCode];
}

// Function to fetch all languages
const fetchLanguages = async () => {
    try {
        const response = await axiosInstance.get<LanguageData[]>("/languages");
        return response.data;
    } catch (error) {
        throw error;
    }
}

export {
    fetchStates,
    fetchStateByCode,
    getStateNameByCode,
    fetchLanguages
};